import { getNewGuid } from '@ane/core/lib/utils/CommonStringUtils';
import { genErrorMessageAvailabilityStreamInfo, genErrorMessageParameterInfo, validateAvailabilityStreamInfo, validateOverrideBasicInfo, validateParameterInfo, } from '../../../DataSourceCreate/utils/DataSourceFormikSettingsUtils';
import _ from 'lodash';
export const convertToOverridePostParams = (props) => {
    var _a;
    let postParams = {
        Version: getNewGuid(),
        WorkspaceId: props.workspaceId,
        IsOverrideDataSource: true,
        Name: (_a = props.name) !== null && _a !== void 0 ? _a : '',
        OverrideInfo: {
            OverrideFrom: {
                DataSourceVersion: props.FromVersion,
                DataSourceName: props.FromName,
            },
            AvailabilityStreams: props.streamList
                ? props.streamList.map(({ DataPath, VC, Cluster }) => ({
                    DataPath,
                    VC,
                    Cluster,
                }))
                : [],
            Parameters: props.parameterList
                ? props.parameterList.map(({ Name, Value, Type, SampleValue }) => ({
                    Name: Name,
                    Value: Value,
                    Type: Type,
                    DefaultValue: SampleValue,
                }))
                : [],
        },
    };
    return postParams;
};
export const DataSourceCreateFormSettings = {
    mapPropsToValues: (props) => {
        const data = props.primaryDataSourceItem.data;
        let parameters = (data === null || data === void 0 ? void 0 : data.Parameters)
            ? data === null || data === void 0 ? void 0 : data.Parameters.map(({ Name, Value, Type, DefaultValue }, key) => ({
                Name: Name,
                Value: Value,
                Type: Type,
                SampleValue: DefaultValue,
                delete: null,
                DoNotInherited: false,
                required: {
                    Name: '',
                    Type: '',
                    Value: '',
                    SampleValue: '',
                },
                placeholder: undefined,
            }))
            : [];
        parameters = genErrorMessageParameterInfo(parameters);
        let streams = (data === null || data === void 0 ? void 0 : data.AvailabilityStreams)
            ? data.AvailabilityStreams.map(({ DataPath, VC, Cluster }, key) => ({
                DataPath: DataPath,
                VC: VC,
                Cluster: Cluster,
                required: {
                    DataPath: '',
                    VC: '',
                    Cluster: '',
                },
                delete: null,
            }))
            : [
                {
                    DataPath: '',
                    VC: '',
                    Cluster: '',
                    delete: null,
                    required: {
                        DataPath: 'Required',
                        VC: 'Required',
                        Cluster: 'Required',
                    },
                },
            ];
        streams = genErrorMessageAvailabilityStreamInfo(streams);
        return {
            name: '',
            parameterList: parameters,
            streamList: streams,
        };
    },
    validate: (values, props) => {
        let errors = {};
        errors = validateOverrideBasicInfo(props.FromName, values);
        errors = validateParameterInfo(values, errors);
        errors = validateAvailabilityStreamInfo(values, errors);
        return errors;
    },
    validateOnChange: true,
    validateOnBlur: true,
    handleSubmit: async (values, bag) => {
        var _a, _b;
        const filteredParameter = _.filter(values.parameterList, (parameter) => {
            return !!parameter.DoNotInherited;
        });
        (_b = (_a = bag.props).onSubmit) === null || _b === void 0 ? void 0 : _b.call(_a, {
            workspaceId: bag.props.workspaceId,
            FromName: bag.props.FromName,
            FromVersion: bag.props.FromVersion,
            name: bag.props.FromName + '-' + values.name,
            parameterList: filteredParameter,
            streamList: values.streamList,
        });
    },
};
export const DataSourceEditFormSettings = {
    mapPropsToValues: (props) => {
        var _a, _b, _c, _d;
        const data = props.defaultDataSource;
        let parameters = data.Parameters
            ? data.Parameters.map(({ Name, Value, Type, DefaultValue }, key) => ({
                Name: Name,
                Value: Value,
                Type: Type,
                SampleValue: DefaultValue,
                delete: null,
                required: {
                    Name: '',
                    Type: '',
                    Value: '',
                    SampleValue: '',
                },
                placeholder: undefined,
            }))
            : [];
        let overrideParameters = ((_a = data.OverrideInfo) === null || _a === void 0 ? void 0 : _a.Parameters)
            ? (_b = data.OverrideInfo) === null || _b === void 0 ? void 0 : _b.Parameters.map(({ Name, Value, Type, DefaultValue }, key) => ({
                Name: Name,
                Value: Value,
                Type: Type,
                SampleValue: DefaultValue,
                DoNotInherited: true,
                delete: null,
                required: {
                    Name: '',
                    Type: '',
                    Value: '',
                    SampleValue: '',
                },
                placeholder: undefined,
            }))
            : [];
        _.each(parameters, (item, key) => {
            _.each(overrideParameters, (itemOverride, keyOverride) => {
                if (item.Name === itemOverride.Name) {
                    parameters = [
                        ...parameters.slice(0, key),
                        {
                            ...itemOverride,
                        },
                        ...parameters.slice(key + 1),
                    ];
                }
            });
        });
        parameters = genErrorMessageParameterInfo(parameters);
        let streams = ((_c = data.OverrideInfo) === null || _c === void 0 ? void 0 : _c.AvailabilityStreams)
            ? (_d = data.OverrideInfo) === null || _d === void 0 ? void 0 : _d.AvailabilityStreams.map(({ DataPath, VC, Cluster }, key) => ({
                DataPath: DataPath,
                VC: VC,
                Cluster: Cluster,
                required: {
                    DataPath: '',
                    VC: '',
                    Cluster: '',
                },
                delete: null,
            }))
            : [];
        streams = genErrorMessageAvailabilityStreamInfo(streams);
        return {
            name: props.name,
            parameterList: parameters,
            streamList: streams,
        };
    },
    validate: (values, props) => {
        let errors = {};
        errors = validateParameterInfo({ ...values, parameterList: values.parameterList }, errors);
        errors = validateAvailabilityStreamInfo({ ...values, streamList: values.streamList }, errors);
        return errors;
    },
    validateOnChange: true,
    validateOnBlur: true,
    handleSubmit: async (values, bag) => {
        const filteredParameter = _.filter(values.parameterList, (parameter) => {
            return !!parameter.DoNotInherited;
        });
        bag.props.savePanel && bag.props.savePanel({ ...values, parameterList: filteredParameter });
    },
};

//# sourceMappingURL=DataSourceCreateFormSettings.js.map
